<template>
  <div class="about">
    <topbar :isVisibleSearch="false"></topbar>
    <div class="container space-about">
      <div class="d-flex justify-content-between">
        <div>
          <img width="450" src="@/assets/about/About_3.svg" alt="about.svg" />
        </div>
        <h4 class="text-left font-weight-normal about-title">
          Website ini berisikan database laboratorium terakreditasi SNI 17025
          oleh KAN. Berbagai informasi seperti skope, rentang uji/kalibrasi,
          metode uji/kalibrasi, obyek uji, dan informasi lainnya dapat diakses
          disini.
        </h4>
      </div>
      <div class="d-flex mt-5">
        <div>
          <h4 class="text-left font-weight-normal">
            Informasi laboratorium pengujian/kalibrasi ini semoga dapat
            mendorong peningkatan kandungan lokal (<i>local content</i> ) dan
            kualitas produk yang dihasilkan, mendorong pengembangan dan
            peningkatan kapabilitas industri dalam negeri maupun kompetensi
            sumber daya manusia. Data fasilitas pengujian/kalibrasi juga dapat
            digunakan sebagai bahan studi sekaligus rekomendasi kepada
            stakeholder/pemerintah untuk peningkatan kapabilitas industri.
          </h4>
          <div class=" text-justify disclaimer">
            <b>Disclaimer: </b> <br />
            <i class="font-weight-bold"
              >Database ini dibuat berdasarkan informasi publik yang didapat
              dari website resmi KAD, BSN, dan sumber lainnya.</i
            >
          </div>
        </div>
        <div class="ml-5 mt-4">
          <img
            width="450"
            class="shadow-lg about-icon"
            src="@/assets/about/About_1.svg"
            alt="about.svg"
          />
        </div>
      </div>
    </div>
    <div class="marginfooter">
      <myfooter></myfooter>
    </div>
  </div>
</template>
<script>
import topbar from "../components/home/topbar.vue";
import myfooter from "../components/home/footer.vue";
export default {
  components: {
    topbar,
    myfooter,
  },
};
</script>

<style scoped>
.space-about {
  margin-top: 140px;
}
.about-title {
  margin-top: 50px;
  width: 500px;
}
.marginfooter {
  margin-top: 20%;
}
.margintext {
  margin-top: 10%;
}
.about-icon {
  border-radius: 24px;
  margin-top: -20px;
}
.disclaimer {
  margin-top: 120px;
}
</style>
